import _axios from '@/utils/request'

// 查询运营列表
export function postAccountList (params) {
    return _axios('post', '/ms-shulan-hospital/v1/backstage/pageBackUser', params)
}

// 添加运营
export function postAddAccount (params) {
    return _axios('post', '/ms-shulan-hospital/v1/backstage', params)
}

// 更新运营
export function putPpdateAccount (params) {
    return _axios('put', '/ms-shulan-hospital/v1/backstage', params)
}

// 获取运营详情
export function getAccount (iuid) {
    return _axios('get', `/ms-shulan-hospital/v1/backstage/${iuid}`)
}

// 用户列表 - 获取验证码
export function postSendVerification (param) {
    return _axios('post', '/ms-shulan-hospital/v1/doctor/sendChangeVerification', param)
}

// 用户列表 -  修改密码
export function putChangePassword (params) {
    return _axios('put', '/ms-shulan-hospital/v1/backstage/changePassword', params)
}
